import { render, staticRenderFns } from "./LoginNeopag.vue?vue&type=template&id=6241b3bc&"
import script from "./LoginNeopag.vue?vue&type=script&lang=js&"
export * from "./LoginNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports